import React from 'react';
import ReactMarkdown from 'lib/react-markdown';
import PropTypes from 'prop-types';
import { Card, Container, Col, Row } from 'reactstrap';
import * as styles from 'styles/index.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const {
  recipeIngredient,
  recipeIngredientContainer,
  recipeIngredientAmount,
  recipeIngredientAmountLabel,
  recipeIngredientAmountValue,
  recipeIngredientImg,
  recipeIngredientName,
  recipeIngredientNotes
} = styles;

const IngredientListItem = props => (
  <p>
    {props.number && <span>{props.number}&nbsp;</span>}
    {props.units && <span>{props.units}&nbsp;</span>}
    {props.name}
    {props.note ? (
      <span className={recipeIngredientNotes}>
        {' ('}
        <ReactMarkdown components={{ p: ({ node, ...props }) => <React.Fragment {...props} /> }}>
          {props.note
            .replace(')', '')
            .replace(/^\(+/, '')
            .replace(' (', ', ')
            .replace(/[\(\)]/, '')}
        </ReactMarkdown>
        {')'}
      </span>
    ) : null}
  </p>
);

IngredientListItem.propTypes = {
  note: PropTypes.string,
  name: PropTypes.string.isRequired,
  number: PropTypes.string.isRequired,
  units: PropTypes.string.isRequired
};

IngredientListItem.defaultProps = {
  note: ''
};

export default IngredientListItem;
